import { useDispatch, useSelector } from 'react-redux';
import { TOGGLE_SIDEBAR_DRAWER, CLOSE_SIDEBAR_DRAWER, CLOSE_ALL_SIDEBARS } from '../store/orgSlice';
import { RootState } from '../store/store';

export const useSidebar = (sidebarId?: string) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state: RootState) => state.software.SidebarDrawer[sidebarId || ""] || false);

    const toggleSidebar = () => {
        dispatch(TOGGLE_SIDEBAR_DRAWER(sidebarId || ""));
    };

    const closeSidebar = () => {
        dispatch(CLOSE_SIDEBAR_DRAWER(sidebarId || ""));
    };

    const closeAll = () => {
        console.log('Dispatching CLOSE_ALL_SIDEBARS'); // Debugging statement
        dispatch(CLOSE_ALL_SIDEBARS());
    };
    

    return { isOpen, toggleSidebar, closeSidebar, closeAll };
};
